// src/pages/Appli/AppliAdmin/VisitorCenter/components/VisitorCenterHeader.jsx

import React from "react";

import {
  FiActivity,
  FiRefreshCw,
} from "react-icons/fi";

import {
  VISITOR_CENTER_TABS,
} from "../data/visitorCenterData";

export default function VisitorCenterHeader({
  activeTab,
  onTabChange,
  onRefresh,
  refreshing = false,
}) {
  return (
    <div className="space-y-5">
      <section className="overflow-hidden rounded-[30px] bg-gradient-to-r from-[#123B57] via-[#1C567F] to-[#2EA7E0] p-6 text-white shadow-[0_18px_50px_rgba(18,59,87,0.2)] lg:p-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em]">
              <FiActivity />

              Centre visiteurs
            </div>

            <h1 className="mt-4 text-3xl font-extrabold tracking-tight lg:text-4xl">
              Activité commerciale en direct
            </h1>

            <p className="mt-3 max-w-3xl text-sm text-white/80 lg:text-base">
              Analysez le trafic, les parcours, les conversations et les demandes commerciales depuis une interface unique.
            </p>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-white/15 bg-white/10 px-5 py-3 text-sm font-bold text-white transition hover:bg-white/20 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FiRefreshCw
              className={
                refreshing
                  ? "animate-spin"
                  : ""
              }
            />

            Actualiser
          </button>
        </div>
      </section>

      <section className="rounded-[26px] border border-slate-200 bg-white p-2 shadow-sm">
        <div className="grid gap-2 md:grid-cols-2 xl:grid-cols-5">
          {VISITOR_CENTER_TABS.map(
            (tab) => {
              const Icon =
                tab.icon;

              const active =
                activeTab ===
                tab.key;

              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() =>
                    onTabChange(
                      tab.key,
                    )
                  }
                  className={`flex items-center gap-3 rounded-2xl px-4 py-3 text-left transition ${
                    active
                      ? "bg-[#123B57] text-white shadow-lg"
                      : "bg-[#F8FBFD] text-slate-700 hover:bg-[#EEF7FC]"
                  }`}
                >
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border text-lg ${
                      active
                        ? "border-white/10 bg-white/10"
                        : "border-slate-200 bg-white text-[#2EA7E0]"
                    }`}
                  >
                    <Icon />
                  </span>

                  <span className="min-w-0">
                    <span className="block font-extrabold">
                      {tab.label}
                    </span>

                    <span
                      className={`block truncate text-xs ${
                        active
                          ? "text-white/70"
                          : "text-slate-500"
                      }`}
                    >
                      {
                        tab.description
                      }
                    </span>
                  </span>
                </button>
              );
            },
          )}
        </div>
      </section>
    </div>
  );
}